/**
 * PriceSpider Widget IDs
 *
 * This file contains widget IDs for various PriceSpider integrations.
 *
 * Architecture note:
 * - Core widget IDs (used site-wide) are configured in gatsby-config.js and
 *   sourced from environment variables for deployment flexibility
 * - Feature-specific or experimental widget IDs are managed here to:
 *   -Avoid hardcoding IDs in component files
 *   -Make removal easier
 *   -Avoid clutering environment variables with temp features
 */

export const PRICESPIDER_WIDGET_IDS = {
  // The DEFAULT ID is defined in gatsby-config.js from environment variables
  // It's accessed in the Widget component via GraphQL query
  DEFAULT: '',

  // The RETAILERS widget is a specialized widget for displaying specific retailers
  // on select products (controlled by field_show_pricespider_retailers in CMS)
  RETAILERS: '67239979cacec9d7800b0403',
};
